import config from '../config';
import { createBrowserHistory } from 'history';
export default createBrowserHistory({ basename: config.basename });
